module.exports = __webpack_public_path__ + "img/beach.3b481f0b.jpg";